import { render, staticRenderFns } from "./Commande.vue?vue&type=template&id=23daf072&"
import script from "./Commande.vue?vue&type=script&lang=js&"
export * from "./Commande.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports